import { render, staticRenderFns } from "./ExpenseApproval.vue?vue&type=template&id=26d1dd38&scoped=true"
import script from "./ExpenseApproval.vue?vue&type=script&lang=js"
export * from "./ExpenseApproval.vue?vue&type=script&lang=js"
import style0 from "@/styles/approval-status.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ExpenseApproval.vue?vue&type=style&index=1&id=26d1dd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d1dd38",
  null
  
)

export default component.exports